import { ChangeEvent, useCallback } from "react"
import { ConceptStatusValueType, ConceptValueDataType } from '@fusion-advantage/backcompat'
import { isConceptStatus } from "@fusion-advantage/formlib"
import { useFormDispatch } from "../../../redux/formStoreHooks"
import { useConceptActivation } from "../../../redux/selectConcept"
import { useConceptStatus, useConceptStatusValidity } from "../../../redux/selectConceptStatus2"
import { useConceptValidator } from "./useConceptValidator"
import { submitStatusUpdates } from "../../../redux/submitStatusUpdates"
import L1ErrorBlock from "../l1/L1ErrorBlock"
import L3TextArea from "../l3/L3TextArea"

interface L4TextAreaProps {
	xpath: string
	cid?: string
}

const L4TextArea = ({xpath, cid}: L4TextAreaProps) => {
	const { errorNode } = useConceptValidator({
		tagName: 'L4TextArea',
		cid,
		requireConcept: true,
		allowDataTypes: [
			ConceptValueDataType.String,
		],
	})
	const conceptStatus = useConceptStatus(cid)
	const validity = useConceptStatusValidity(cid)
	const activation = useConceptActivation(cid)
	const dispatch = useFormDispatch()
	const handleChange = useCallback((e: ChangeEvent<HTMLTextAreaElement>) => {
		dispatch(submitStatusUpdates([{
			cid: cid!,
			value: e.target.value,
			valueType: ConceptStatusValueType.Chosen,
		}]))
	}, [dispatch, cid])
	if(errorNode) {
		return errorNode
	}
	if(conceptStatus && !isConceptStatus(conceptStatus)) {
		// probably passed SuperconceptStatus instead of ConceptStatus
		// which doesn't make sense for this control
		return <L1ErrorBlock content={`[L4TextArea ${cid}] conceptStatus is incorrect type`} />
	}
	return (
		<L3TextArea
			xpath={xpath}
			conceptStatus={conceptStatus}
			validity={validity}
			activation={activation}
			onChange={handleChange}
		/>
	)
}

export default L4TextArea
